/**
 * Nombre d'actualités publiées depuis la dernière ouverture du fil.
 *
 * Sert le petit chiffre posé sur « Actualités » (en-tête) et « Actus » (barre du
 * bas). Il s'éteint dès que le fil est ouvert — c'est ce que remplace l'ancienne
 * pastille verte flottante, qui restait 24 h en travers des autres boutons.
 */

import { useEffect, useState } from 'react';
import { usePublications } from './usePublications';
import { useTenant } from '../contexts/TenantContext';
import { derniereOuvertureDuFil, EVENEMENT_VU } from '../utils/publicationsSeen';

export function useNewPublicationsCount(): number {
  const { tenant } = useTenant();
  const { publications } = usePublications({ status: 'PUBLISHED', limit: 20 }, tenant?.id || '');
  const [depuis, setDepuis] = useState<Date>(() => derniereOuvertureDuFil());

  useEffect(() => {
    const relire = () => setDepuis(derniereOuvertureDuFil());
    // Ouverture du fil dans cet onglet…
    window.addEventListener(EVENEMENT_VU, relire);
    // …ou dans un autre onglet du même navigateur.
    window.addEventListener('storage', relire);
    return () => {
      window.removeEventListener(EVENEMENT_VU, relire);
      window.removeEventListener('storage', relire);
    };
  }, []);

  // Réponse inattendue (pas une liste) : 0, jamais une page blanche — ce
  // compteur vit dans l'en-tête de TOUTE la boutique.
  if (!Array.isArray(publications)) return 0;
  return publications.filter((pub) => {
    const parution = new Date(pub.published_at || pub.created_at);
    return !isNaN(parution.getTime()) && parution > depuis;
  }).length;
}
